<template>
    <span @click="showModal()" class="utc-link">
        <slot>{{ userTimezone.code }}</slot>
    </span>
</template>
<script>

// Import external libraries
import { mapState } from 'vuex';
import { escapeHtml } from '@/plugins/dialog';

export default {
    computed: {
        /**
         * State of user timezone
         *
         * userTimezone    State of the logged in user timezone
         */
        ...mapState('core/auth', [
            'userTimezone'
        ])
    },

    methods: {
        showModal () {
            const timezone = this.$t('timezone-modal', {
                timezone: escapeHtml(this.userTimezone.code),
                offset:   escapeHtml(this.userTimezone.offset)
            });

            this.$dialog.alert({
                html:   `${timezone}<br><br>${this.$t('utc-modal')}`,
                okText: this.$t('close')
            });
        }
    }
};
</script>
